// MEDIA QUERIES
export const smallerThanDesktop = 'max-width: 1199px';
export const smallerThanTabletLandscape = 'max-width: 899px';
export const phoneOnly = 'max-width: 599px';
